import { clientRecords, extractError, parentAccountApi } from '@atheneum/api'
import { action, computed, extendObservable } from 'mobx'

class ParentAccountStore {
  constructor (staticData, growlStore) {
    extendObservable(this, {
      id: null,
      parentAccount: null,
      loading: false,
      error: null,
      accountType: computed(() => {
        // if(!this.parentAccount) return ''
        return staticData.names.accountTypes[this.parentAccount.accountTypeId]
      }),
      invoicingCoverage: computed(() => {
        const invCoverageId = this.parentAccount.invoicingCoverageId
        return staticData.names.invoicingCoverages[invCoverageId]
      }),
      projectCount: null,
      projectFeedback: null,
      projectFeedbackAvg: computed(() => {
        if (this.projectFeedback) {
          return this.projectFeedback.toFixed(2)
        } else {
          return 'N/A'
        }
      }),
      invoicingEntities: null,
      globalInvoicingEntity: computed(() => {
        return this.invoicingEntities.rows.find(row => row.isGlobal)
      }),
      requiredCode: computed(() => {
        if (this.parentAccount.caseCodeRequired) {
          return 'Required'
        } else {
          return 'Not required'
        }
      }),
      expertsDisclosed: computed(() => {
        if (this.parentAccount.expertsDisclosed) {
          return 'Yes'
        } else {
          return 'No'
        }
      }),
      growlStore
    })
  }

  load (id) {
    this.id = Number(id)
    this.loading = true

    Promise.all([
      clientRecords.getParentAccount(id),
      clientRecords.getProjectCount(id),
      clientRecords.getFeedbacks(id),
      clientRecords.getInvoicingEntities(id)
    ])
      .then(
        ([
          parentAccount,
          projectCount,
          projectFeedback,
          invoicingEntities,
          accounts,
          offices
        ]) => {
          this.parentAccount = parentAccount
          this.projectCount = projectCount
          this.projectFeedback = projectFeedback.ratingAvg
          this.invoicingEntities = invoicingEntities
        }
      )
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  deleteParentAccount = action(parentAccountId => {
    return parentAccountApi.deleteParentAccount(parentAccountId).catch(err => {
      this.error = extractError(err)
      this.growlStore.addNotification({
        title: 'Error!',
        message: this.error.message,
        type: 'error',
        autoClose: true
      })

      throw err
    })
  })
}

export default ParentAccountStore
